<script>
	import PageSection from "../../components/PageSection.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";
	import DropZone from "../../components/DropZone.svelte";
	import ClassActionPhoneNumber from "../../components/ClassActionPhoneNumber.svelte";
	import ClassActionEmailAddress from "../../components/ClassActionEmailAddress.svelte";
	import Form from "../../components/Form.svelte";
	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";

	import { acceptedFileUploadList } from "../../config";
	import model from "../../stores/modelStore";

	export let pageIndex = null;
	export let pageTitle = null;
	export let persistUrl = null;

	let buttons;
	let id = "fileUploader";
	let options = {
		url: "/api/file-upload?token=" + $model.registrationToken,
		acceptedFiles: acceptedFileUploadList
	};

	$model.documentList = $model.documentList || [];

	document.title = pageTitle;

	const handleSubmit = async () => {
		console.log("Files submit");
		buttons.blockNext();
		if (persistUrl) {
			try {
				let response = await model.saveModelAsync(persistUrl);

				if (!response.success) {
					console.log("Error", response);
				} else {
					buttons.next();
					//trackSubmit(projectSettings.classActionName);
				}
			} catch (e) {
				console.log("Files Error", e);
			}
		}
		buttons.unblock();
	};
</script>

<PageSection>
	<div class="form-row">
		<!-- <div class="form-row" transition:slide> -->
		<div class="form-group col-md-12">
			<h1>Supporting Documentation</h1>
			<p>
				Please provide documentary evidence of your purchase of the vehicle. Supporting documents may include
				purchase documents, leasing documents, financial statements, or insurance documents.
			</p>

			<br />
			<DropZone
				{options}
				{id}
				message="Drop files here or click to upload"
				bind:documentList={$model.documentList}
			></DropZone>
		</div>
	</div>

	<Form id="form-files-page" on:submit={handleSubmit}>
		<FormRow class="justify-content-md-center register-btn confirmation-hide">
			<FormColumn class="text-center">
				<NavigationButtons showPrevious={false} bind:buttons nextPageLabel="Next"></NavigationButtons>
			</FormColumn>
		</FormRow>
	</Form>
</PageSection>
